export const CURRENT_FORMULA_WEIGHTS = { claims: 50, stars: 30, dealerWait: 20 };
export const PREVIOUS_FORMULA_WEIGHTS = { claims: 50, lateness: 35, stars: 15 };
export const PREVIOUS_FORMULA_FULL_SCORE_STARS = 4.9;
export const PREVIOUS_FORMULA_ZERO_SCORE_STARS = 4.5;
